import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import PortalHeaderHamburgerMenu from './PortalHeaderHamburgerMenu/PortalHeaderHamburgerMenu';


export default function PortalHeaderHamburger({isParent}) {

    const [showMenu, setShowMenu] = useState(false);

    //This page should not really need any editing
    return(
        <>
            <GiHamburgerMenu className={'hamburger-icon'} onClick={() => setShowMenu(!showMenu)} />
            {showMenu &&<PortalHeaderHamburgerMenu isParent={isParent} setShowMenu={setShowMenu}/>}
        </>
    )
}